import { render, staticRenderFns } from "./GeneticSimilarityProximity.vue?vue&type=template&id=98b6cf94&scoped=true"
import script from "./GeneticSimilarityProximity.vue?vue&type=script&lang=js"
export * from "./GeneticSimilarityProximity.vue?vue&type=script&lang=js"
import style0 from "./GeneticSimilarityProximity.vue?vue&type=style&index=0&id=98b6cf94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b6cf94",
  null
  
)

export default component.exports